/* globals document, window */
import React from "react";

import Header from "./Header";

const HeaderContainer = (props: Object) => {
  return <Header {...props} />;
};

export default HeaderContainer;
